import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const api = {
  // Plans
  getPlans: () => axios.get(`${API}/plans`, { headers: getAuthHeaders() }),

  // Videos
  getVideos: () => axios.get(`${API}/videos`, { headers: getAuthHeaders() }),
  createVideo: (data) => axios.post(`${API}/videos`, data, { headers: getAuthHeaders() }),

  // Quiz
  getQuizQuestions: (categoria = null) => {
    const params = categoria ? { categoria } : {};
    return axios.get(`${API}/quiz/questions`, { headers: getAuthHeaders(), params });
  },
  submitQuiz: (data) => axios.post(`${API}/quiz/submit`, data, { headers: getAuthHeaders() }),
  getQuizScores: () => axios.get(`${API}/quiz/scores`, { headers: getAuthHeaders() }),
  createQuizQuestion: (data) => axios.post(`${API}/quiz/questions`, data, { headers: getAuthHeaders() }),

  // Word Search
  getWordSearchPuzzles: () => axios.get(`${API}/wordsearch/puzzles`, { headers: getAuthHeaders() }),
  submitWordSearch: (data) => axios.post(`${API}/wordsearch/submit`, data, { headers: getAuthHeaders() }),
  createWordSearchPuzzle: (data) => axios.post(`${API}/wordsearch/puzzles`, data, { headers: getAuthHeaders() }),

  // Payments
  createPixPayment: (valor) => axios.post(`${API}/payments/create-pix`, { valor }, { headers: getAuthHeaders() }),
  checkPayment: (paymentId) => axios.get(`${API}/payments/check/${paymentId}`, { headers: getAuthHeaders() }),
  getPaymentHistory: () => axios.get(`${API}/payments/history`, { headers: getAuthHeaders() }),
};
